import { OptionItem } from "@interface48/api";
import { SelectValue } from "../models";

export const getSelectedOptionItem = <T, L = string>(
  optionItems: Array<OptionItem<T, L>> | undefined,
  value: SelectValue<T>,
  multiple?: boolean,
): OptionItem<T, L> | Array<OptionItem<T, L>> | undefined => {
  let selectedOptionItem: OptionItem<T, L> | Array<OptionItem<T, L>> | undefined;

  if (multiple) {
    const values = value as Array<T>;
    selectedOptionItem = values && optionItems && optionItems.filter(oi => values.some(nv => nv === oi.value));
  } else {
    selectedOptionItem = optionItems && optionItems.find(option => option.value === value);
  }

  return selectedOptionItem;
};
